/* eslint-disable react/prop-types,react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DocumentTitle from 'utils/DocumentTitle';

import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import LargePreLoader from '../../../../../components/Common/PreLoaders/LargePreLoader';
import Content from './Content';

const tasksCollectionRName = 'tasksModule.collections.tasksCollection';

class TaskViewAsOwner extends Component {
  constructor(props) {
    super(props);
    this.props.sendRequest();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (!this.props.task) {
      return <LargePreLoader />;
    }
    if (this.props.task.ownerId !== this.props.authUserId) {
      this.props.history.replace(`/earn-money/task-view/${this.props.task.id}`);
    }
    return (
      <DocumentTitle title={`${this.props.task.title}`}>
        <Content {...this.props} />
      </DocumentTitle>
    );
  }
}

TaskViewAsOwner.defaultProps = {
  task: null
};

TaskViewAsOwner.propTypes = {
  // CONNECT
  sendRequest: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    ownerId: PropTypes.number.isRequired
  }),
  authUserId: PropTypes.number.isRequired
};

const mapStateToProps = (state, props) => ({
  authUserId: selectUserId(state),
  requestState: selectRequestsStateById(
    state,
    tasksCollectionRName,
    props.match.params.taskId
  ),
  task: selectItemById(state, tasksCollectionRName, props.match.params.taskId)
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () =>
    dispatch(dataRequest(tasksCollectionRName, props.match.params.taskId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskViewAsOwner);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskViewAsOwner/index.js